import angular from 'angular';

export const widgetTypes = {
    agenda: 4,
    searchPresetCounts: 7,
    opportunitiesTable: 8,
};

angular.module('AaApp.Opp').constant('widgetTypes', widgetTypes);
